<div class="editor-wrapper">
  <div #editorContainer class="editor-container" [class.expanded]="expanded"></div>
  <div *ngIf="isLoading" class="editor-loader">
    <nz-spin nzSpinning="true" nzSize="large"></nz-spin>
  </div>
</div>
